import { Flex, Spin } from "antd";
import React, { useEffect, useRef, useState } from "react";
  const contentStyle = {
  padding: 15,
  background: 'rgba(0, 0, 0, 0.05)',
  borderRadius: 4,
};
const content = <div style={contentStyle} />;

const UsbDeviceListCompoent = ({ isInvoice, findPrinterData, passDeviceInfo, inputData }) => {
  const [msg, setMsg] = useState("");

  const handleDiviceClick = (device) => {
    passDeviceInfo(device);
  };

  useEffect(() => {
    console.log("-----dependency executed----UsbDeviceListCompoent------", {
      isInvoice,
      findPrinterData,
    });
  }, [isInvoice, findPrinterData]);



  return (
    <div>
      {!findPrinterData.isLoadingPrinter &&
        findPrinterData.printerList.map((name, indx) => (
          <div
            key={indx}
            className={`p-2 mt-5 cursor-pointer ${
              inputData.printerName === name ? "bg-[#2EC114] text-white font-semibold" : ""
            }`}
            style={{
              border: "1px solid #2EC114", // primary color
              borderRadius: "8px",
            }}
            onClick={() => handleDiviceClick(name)}
          >
            Name: {name}
          </div>
        ))}

      {findPrinterData.isLoadingPrinter && (
        <div
          className="p-5  mt-2"
          style={{
            border: "1px solid #FA6060",
            borderRadius: "8px",
          }}
        >
          <Flex gap="middle" vertical>
            <Spin tip="Loading Printers" size="small">
              {content}
            </Spin>
          </Flex>
        </div>
      )}

      {!findPrinterData.isLoadingPrinter && findPrinterData.message !== "" && (
        <div
          className="p-5  mt-2 min-h-[76px] text-center"
          style={{
            border: "1px solid #FA6060", // primary color
            borderRadius: "8px",
          }}
        >
          {findPrinterData.message}
        </div>
      )}
    </div>
  );
};

export default UsbDeviceListCompoent;
